@if (isSpinnerVisible) {
  <div class="loader-container">
    <div class="loader-circle"></div>
  </div>
}
